import template from './forbidden.html';
import './forbidden.styl';

const forbiddenComponent = {
  template
};

export default forbiddenComponent;


/** WEBPACK FOOTER **
 ** ./frontend/components/errors/forbidden/forbidden.component.js
 **/